import axios from 'axios'
import { Service } from 'axios-middleware'
import ErrorMiddleware from './error-middleware'

const service = new Service(axios);

service.register(new ErrorMiddleware())
